
import PlotModel from '../PlotModel';
import PropertyDescriptor from '../../../designer/utils/PropertyDescriptor';
import PageSettingsProperty from './PageSettingsProperty';

export default class Model extends PlotModel {

    settings = new PropertyDescriptor(new PageSettingsProperty(), "设置", "高级", "propertygrid", "#anticon-profile-setting", {
        gallery: "外观",
        valueTemplate: PageSettingsProperty,
    });

    constructor(opts = {}) {
        super();

        this.defineAllProperties();

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "PlotPageModel";
    }

    toStyle() {
        return this.settings.toStyle();
    }
}
